var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("breadcrumb-top", { attrs: { breadcrumbConfig: _vm.dataList } }),
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm.$route.query.type == "add"
            ? _c("h2", [_vm._v("新增优惠券")])
            : _vm._e(),
          _vm.$route.query.type == "edit"
            ? _c("h2", [_vm._v("编辑优惠券")])
            : _vm._e(),
          _c(
            "el-form",
            {
              ref: "ruleForm",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-width": "130px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "优惠券名称", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "490px" },
                    attrs: {
                      maxlength: "20",
                      "show-word-limit": "",
                      placeholder: "请输入优惠券名称",
                    },
                    model: {
                      value: _vm.formData.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "name", $$v)
                      },
                      expression: "formData.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { label: "使用平台", prop: "platformIds" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "490px" },
                      attrs: { placeholder: "请选择平台", multiple: "" },
                      model: {
                        value: _vm.formData.platformIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "platformIds", $$v)
                        },
                        expression: "formData.platformIds",
                      },
                    },
                    _vm._l(_vm.platformList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { label: "适用商品", prop: "type" },
                },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: 1 },
                      model: {
                        value: _vm.formData.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "type", $$v)
                        },
                        expression: "formData.type",
                      },
                    },
                    [_vm._v("全部商品")]
                  ),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: 2 },
                      model: {
                        value: _vm.formData.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "type", $$v)
                        },
                        expression: "formData.type",
                      },
                    },
                    [_vm._v("选择商品")]
                  ),
                ],
                1
              ),
              _vm.formData.type == "2"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.selectGoods },
                        },
                        [_vm._v("选择商品")]
                      ),
                      _vm.allList.length > 0
                        ? _c(
                            "div",
                            { staticClass: "goods-box" },
                            _vm._l(_vm.allList, function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: item.id,
                                  staticStyle: {
                                    width: "100%",
                                    display: "flex",
                                    "justify-content": "space-between",
                                  },
                                },
                                [
                                  _c("div", [
                                    _c("div", { staticClass: "goods-item" }, [
                                      _c("div", { staticClass: "number-dot" }, [
                                        _vm._v(_vm._s(index + 1)),
                                      ]),
                                      _c("p", { staticClass: "goods-title" }, [
                                        _vm._v(_vm._s(item.name)),
                                      ]),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "del",
                                          on: {
                                            click: function ($event) {
                                              return _vm.delFn(index)
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      ),
                                    ]),
                                  ]),
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { label: "优惠券优惠金额", prop: "price" },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "128px" },
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.formData.price,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "price", $$v)
                      },
                      expression: "formData.price",
                    },
                  }),
                  _c("span", { staticStyle: { "margin-left": "12px" } }, [
                    _vm._v("元"),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { label: "最低满足金额", prop: "minPrice" },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "128px" },
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.formData.minPrice,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "minPrice", $$v)
                      },
                      expression: "formData.minPrice",
                    },
                  }),
                  _c("span", { staticStyle: { "margin-left": "12px" } }, [
                    _vm._v("元"),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { label: "起止时间", prop: "dateArr" },
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.formData.dateArr,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "dateArr", $$v)
                      },
                      expression: "formData.dateArr",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { label: "有效时间", prop: "expireDate" },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "128px" },
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.formData.expireDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "expireDate", $$v)
                      },
                      expression: "formData.expireDate",
                    },
                  }),
                  _c("span", { staticStyle: { "margin-left": "12px" } }, [
                    _vm._v("天"),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { label: "优惠券内容说明", prop: "couponText" },
                },
                [
                  _c("el-input", {
                    staticClass: "inputarea",
                    staticStyle: { width: "466px" },
                    attrs: {
                      type: "textarea",
                      maxlength: "60",
                      resize: "none",
                      placeholder: "请输入说明",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.formData.couponText,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "couponText", $$v)
                      },
                      expression: "formData.couponText",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { label: "状态", prop: "status" },
                },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: 1 },
                      model: {
                        value: _vm.formData.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "status", $$v)
                        },
                        expression: "formData.status",
                      },
                    },
                    [_vm._v("启用")]
                  ),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: 0 },
                      model: {
                        value: _vm.formData.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "status", $$v)
                        },
                        expression: "formData.status",
                      },
                    },
                    [_vm._v("禁用")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content bottom-but" },
        [
          _c(
            "el-button",
            { attrs: { type: "warning" }, on: { click: _vm.toBack } },
            [_vm._v("返回")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submitFn } },
            [_vm._v("确认")]
          ),
          _c("div", { staticStyle: { height: "20px" } }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择商品",
            "append-to-body": true,
            "close-on-click-modal": false,
            visible: _vm.dialogVisible,
            width: "815",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "600px", "overflow-y": "auto" } },
            [
              _c(
                "div",
                { staticClass: "search-box" },
                [
                  _c("el-input", {
                    staticStyle: { width: "224px", "margin-right": "20px" },
                    attrs: {
                      placeholder: "请输入商品名称/商品编号",
                      size: "mini",
                    },
                    model: {
                      value: _vm.goodsName,
                      callback: function ($$v) {
                        _vm.goodsName = $$v
                      },
                      expression: "goodsName",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini", plain: "" },
                      on: {
                        click: function ($event) {
                          _vm.pageNo = 1
                          _vm.couponGoodsPageList()
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  attrs: {
                    data: _vm.goodsList,
                    "show-header": false,
                    border: "",
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "60" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "goodsName", label: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticStyle: { display: "flex" } }, [
                              _c("img", {
                                staticStyle: {
                                  width: "72px",
                                  height: "56px",
                                  "margin-right": "12px",
                                },
                                attrs: { src: scope.row.image, alt: "" },
                              }),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "14px",
                                    height: "56px",
                                    display: "flex",
                                    "flex-direction": "column",
                                    "justify-content": "space-between",
                                  },
                                },
                                [
                                  _c(
                                    "p",
                                    { staticStyle: { color: "#333333" } },
                                    [_vm._v(_vm._s(scope.row.name))]
                                  ),
                                  _c(
                                    "p",
                                    { staticStyle: { color: "#999999" } },
                                    [
                                      _vm._v(
                                        " 商品编号：" +
                                          _vm._s(scope.row.goodsNo) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "center",
                    "align-items": "center",
                    height: "42px",
                  },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      "current-page": _vm.pageNo,
                      "page-sizes": [5, 10, 20, 30],
                      "page-size": _vm.pageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.totalNum,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirmFn } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }